export function checkDashboardsPath(target) {
    return window.location.pathname == `/dashboards` ? target : '.none'
}
export function checkShowListPath(target) {
    return window.location.pathname == `/employees` ? target : '.none'
}
export function checkNewPath(target) {
    return window.location.pathname == `/employees/new` ? target : '.none'
}